import axios from 'axios'

function configureAxios({ api_base_url, convention_host }) {
	if (api_base_url) {
		axios.defaults.baseURL = api_base_url
	}

	axios.defaults.withCredentials = true
	axios.defaults.xsrfCookieName = 'X-CSRF-Token'
	axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
	axios.defaults.headers.common['X-Front-End-Build-Number'] = process.env.BUILD_NUMBER

	if (typeof window !== 'undefined' && (convention_host || window.location?.hostname)) {
		axios.defaults.headers.common['X-Convention-Host'] = convention_host || window.location.hostname
	}
}

axios.interceptors.response.use(
	(response) => {
		if (response.headers['x-highest-front-end-build-number']) {
				sessionStorage.setItem(
				'highest_front_end_build_number',
				response.headers['x-highest-front-end-build-number'],
			)
		}
		return response
	},
	(error) => Promise.reject(error),
)

export default configureAxios

export {
	configureAxios,
}
